import style from './style.css';
import { Button } from 'preact-material-components';
import { Fragment } from 'preact';
import { tracker, UserActionType } from '../../../../tracking';

const KnowMoreButton = ({
  buttonId = 'verifyButton',
  buttonOnClick,
  buttonText,
  elementName,
  pageKey,
}) => {
  return (
    <Fragment>
      <div>
        <Button
          id='verify-eligibility-button'
          raised
          ripple
          className={`${style.buttonOpacity}`}
          id={buttonId}
          onClick={() => {
            tracker.trackUserInteraction(
              UserActionType.CLICK,
              elementName,
              pageKey,
            );
            return buttonOnClick();
          }}>
          {buttonText}
        </Button>
      </div>
    </Fragment>
  );
};

export default KnowMoreButton;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/nonApprovedUserCard/knowMoreButton/index.js